import { fetchFlask } from '../../utils/fetchFlask';
import { formatInteger, ratio } from '../../utils/numberUtils';

export const fetchDashboardAluguel = async ({ dataInicio, dataFim }) => {
    const response = await fetchFlask('dashboardAluguel', JSON.stringify({
        data_inicio: dataInicio,
        data_fim: dataFim
    }));
    return response.dashboard;
};

export const buildDashboardAluguelGauges = ({ boletos, nps, trocas }, periodQuery) => [
    {
        key: 'cancelamentos',
        title: 'Cancelamento de boletos',
        value: ratio(boletos.quantidade_cancelados, boletos.quantidade_emitidos),
        max: 0.05,
        meta: 0.01,
        lowerIsBetter: true,
        detail: `${formatInteger(boletos.quantidade_cancelados)} de ${formatInteger(boletos.quantidade_emitidos)} boletos`
    },
    {
        key: 'atrasos',
        title: 'Atrasos',
        value: ratio(boletos.quantidade_atrasados, boletos.quantidade_emitidos),
        max: 0.05,
        meta: 0.01,
        lowerIsBetter: true,
        detail: `${formatInteger(boletos.quantidade_atrasados)} de ${formatInteger(boletos.quantidade_emitidos)} boletos`
    },
    {
        key: 'csat',
        title: 'CSAT',
        value: ratio(nps.quantidade_satisfeitos, nps.quantidade_respostas),
        meta: 0.75,
        detail: `${formatInteger(nps.quantidade_satisfeitos)} de ${formatInteger(nps.quantidade_respostas)} respostas`,
        to: 'BIGE/nps'
    },
    {
        key: 'trocas',
        title: 'Conclusão de trocas',
        value: ratio(trocas.entrantes - trocas.em_aberto, trocas.entrantes),
        meta: 1,
        detail: `${formatInteger(trocas.em_aberto)} de ${formatInteger(trocas.entrantes)} em aberto`,
        to: `BIGE/trocasTitularidade${periodQuery}`
    }
];
